import { useCallback, useMemo, useState } from 'react';

import { contactGroupService } from 'contacts/services';
import { IContactGroup } from 'contacts/types';
import { TableLayoutType } from 'core/enums';
import { AgGridServerTableProvider } from 'core/states';
import { AgGridGetRowsParams } from 'core/types';
import { removeNullValuesNestedObject } from 'core/utils';

import { columnDef } from './columns';
import { CustomerContactGroupListTable } from './CustomerContactGroupListTable';

export const CustomerContactGroupList = () => {
  const [selectedContactGroup, setSelectedContactGroup] = useState<IContactGroup | null>(null);

  const openDetails = useCallback((data: IContactGroup) => setSelectedContactGroup(data), []);

  const columnDefs = useMemo(() => columnDef(openDetails), [openDetails]);

  const defaultColDef = useMemo(() => ({ autoHeight: true }), []);

  const getRows = useCallback(({ filters, ...rest }: AgGridGetRowsParams) => {
    return contactGroupService.getContactGroups(
      removeNullValuesNestedObject({
        filters: {
          isCustomer: '"1"',
          ...filters,
        },
        ...rest,
      })
    );
  }, []);

  return (
    <AgGridServerTableProvider
      tableId="customerContactGroupListTable"
      entityType="Company"
      columnDefs={columnDefs}
      defaultColDef={defaultColDef}
      getRows={getRows}
      layoutType={TableLayoutType.CUSTOMER_CONTACT_GROUP}
      hasLayoutActions
      hasManageFilters
    >
      <CustomerContactGroupListTable
        selectedContactGroup={selectedContactGroup}
        setSelectedContactGroup={setSelectedContactGroup}
      />
    </AgGridServerTableProvider>
  );
};
